/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import { IClientDto } from '../Client.model'
import classNames from 'classnames'
import { useIntl } from 'react-intl'
import { IconLabelContent } from '../../../common/component/IconLabelContent'

interface Props {
  disabled?: boolean
  data: IClientDto
  rowSelected?: string
  backgroundClass?: string
  hoverBackgroundClass?: string
  onRowClick?: (id: string) => void
  removeOnClick?: (id: string) => void
}

export const ClientListItem: FC<Props> = ({
  disabled,
  data,
  rowSelected,
  backgroundClass = 'bg-light-primary',
  hoverBackgroundClass = 'bg-hover-light-primary',
  onRowClick,
  removeOnClick,
}: Props) => {
  const intl = useIntl()
  const backGroundClasses = {}
  backGroundClasses[`d-flex flex-stack py-2 ${backgroundClass}`] = data.id === rowSelected
  
  const hoverBackGroundClasses = {}
  hoverBackGroundClasses[`d-flex flex-stack py-2 ${hoverBackgroundClass}`] = data.id !== rowSelected
  
  const buildDescriptionLine = (data: IClientDto) => {
    let description = `${data.sector}`
    if (data.address) {
      description += description ? ` | ${data.address}` : `${data.address}`
    }

    return description
  }

  return (
    <div
      className={classNames(backGroundClasses, hoverBackGroundClasses)}
      onClick={() => onRowClick && onRowClick(data.id)}
    >
      <div className='d-flex flex-stack'>
        <div className='d-flex align-items-center'>
          {!disabled && removeOnClick && (
            <div className='row'>
              <div className='d-flex justify-content-end align-items-center'>
                <button
                  type='button'
                  className='btn btn-sm btn-icon'
                  onClick={() => removeOnClick(data.id)}
                >
                  <i className='bi bi-x fs-1 fw-bold text-danger'></i>
                </button>
              </div>
            </div>
          )}

          <div className='ms-2'>
            <div className='fs-7'>
              <span className='fw-bolder mb-2'>{data.displayName}</span>
              <span className='text-gray-600 ms-2 me-2 mb-2'>-</span>
              <span className='text-primary mb-2'>{data.sequence}</span>
            </div>

            <div className='d-flex justify-content-start'>
              <div className='d-flex align-items-center fs-8'>
                <span className='text-gray-600'>{buildDescriptionLine(data)}</span>
              </div>
            </div>

            <div className='d-flex justify-content-start align-items-center'>
              <IconLabelContent
                title={`${intl
                  .formatMessage({id: 'TITLE.CONTRACT.TOTAL'})
                  .replace(/%s/g, `${data.totalContract > 0 ? data.totalContract : 0}`)}`}
                labelValue={`${data.totalContract || 0}`}
                active={data.totalContract > 0}
                icon='bi bi-vector-pen'
              />

              <IconLabelContent
                title={`${intl
                  .formatMessage({id: 'TITLE.ASSET.TOTAL'})
                  .replace(/%s/g, `${data.totalAsset > 0 ? data.totalAsset : 0}`)}`}
                labelValue={`${data.totalAsset || 0}`}
                active={data.totalAsset > 0}
                icon='bi bi-cpu'
              />

              <IconLabelContent
                title={`${intl
                  .formatMessage({id: 'TITLE.REPORT.TOTAL'})
                  .replace(/%s/g, `${data.totalReport > 0 ? data.totalReport : 0}`)}`}
                labelValue={`${data.totalReport || 0}`}
                active={data.totalReport > 0}
                icon='bi bi-speedometer'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
